import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function PremiumUsersCard() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPremiumUsers() {
      try {
        const snap = await getDocs(collection(db, "users"));

        let premiumTotal = 0;

        snap.forEach((doc) => {
          const plan = (doc.data().plan || "").toLowerCase();

          // 🎯 Contagem de planos pagos
          if (
            plan === "starter" ||
            plan === "premium" ||
            plan === "mensal" ||
            plan === "monthly" ||
            plan === "anual" ||
            plan === "annual"
          ) {
            premiumTotal++;
          }
        });

        setCount(premiumTotal);
      } catch (error) {
        console.error("Erro ao carregar usuários premium:", error);
      } finally {
        setLoading(false);
      }
    }

    loadPremiumUsers();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Usuários Premium</p>

      <p className="metric-value">
        {loading || count === null ? "..." : count.toLocaleString("pt-BR")}
      </p>

      <span className="metric-tag">Planos pagos ativos</span>
    </div>
  );
}
